import BaseService from '../BaseService'

class BuyerService extends BaseService {
    constructor() {
        super('/buyers');
    }
}

export default new BuyerService()
